module.exports = __webpack_public_path__ + "static/img/product-h30.7bf8b68b.png";